
<template lang="pug">
.maintenance
  .maintenance__title 準備中です。
  div しばらくお待ちいただいてから　
  div 再度アクセスをお試しください。
  .maintenance__footer(v-if="maintenanceMessage") {{maintenanceMessage}}
</template>

<script>
import {mapActions} from 'vuex'

import {mapAuto} from 'helpers/vuex-bind'

export default {
  data() {
    return {
      retryTimer: null,
    }
  },

  computed: {
    ...mapAuto(['maintenanceMessage', 'maintenanceRetryAfter']),
  },

  watch: {
    maintenanceRetryAfter: {
      immediate: true,
      handler(value) {
        this.beginRetryTimer(value)
      },
    },
  },

  beforeDestroy() {
    this.endRetryTimer()
  },

  methods: {
    ...mapActions(['fetchConfig']),

    beginRetryTimer(waitSeconds) {
      this.endRetryTimer()
      if(0 < waitSeconds) {
        this.retryTimer = setTimeout(this.retry, waitSeconds * 1000)
      }
    },

    endRetryTimer() {
      if(this.retryTimer != null) {
        clearTimeout(this.retryTimer)
        this.retryTimer = null
      }
    },

    async retry() {
      const maintenanceRetryAfter = this.maintenanceRetryAfter
      try {
        this.maintenanceRetryAfter = null
        await this.fetchConfig()
      }
      catch(e) {
        this.maintenanceRetryAfter = maintenanceRetryAfter
      }
    },
  },
}
</script>

<style lang="sass">
.maintenance
  align-items: center
  display: flex
  flex-direction: column
  height: 100%
  justify-content: center

.maintenance__title
  font-size: 32px
  margin-bottom: 10px

.maintenance__footer
  margin-top: 10px
</style>
